import { render, staticRenderFns } from "./CannedMessageSelector.vue?vue&type=template&id=1c9baf4a&scoped=true"
import script from "./CannedMessageSelector.vue?vue&type=script&lang=js"
export * from "./CannedMessageSelector.vue?vue&type=script&lang=js"
import style0 from "./CannedMessageSelector.vue?vue&type=style&index=0&id=1c9baf4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9baf4a",
  null
  
)

export default component.exports